import React from "react";
import classNames from "classnames";
import styles from "../../table.module.scss";

type TableDataProps = React.HTMLAttributes<HTMLTableCellElement>;

const TData = ({ ...props }: TableDataProps) => (
  <td {...props} className={classNames(styles.td, props.className)}>
    {props.children}
  </td>
);

export default TData;
